// clarity.service.ts
import { Injectable } from '@angular/core';
import { sha256 } from '../util/hash.util';


declare var clarity: any;

@Injectable({
    providedIn: 'root'
})
export class ClarityService {
    private hasTracked = false;

    async trackUser(user: {
        userId: number;
        email: string;
        phoneNumber: string;
    }): Promise<void> {
        if (typeof clarity !== 'function' || this.hasTracked) return;
      console.log("user id"+user.userId)
        console.log("user email"+user.email)
          console.log("user phone no"+user.phoneNumber)
        // Set safe (non-PII) values
        clarity('set', 'user_id', user.userId);

        // Set hashed (PII) values
        const hashedEmail = await sha256(user.email);
        const hashedPhone = await sha256(user.phoneNumber);

        clarity('set', 'user_email_hash', hashedEmail);
        clarity('set', 'user_phone_hash', hashedPhone);


        this.hasTracked = true;
    }
}
